<template>  
    <div>
        <HeaderBar/>
        <div class="auth-wrapper auth-v2">
            <b-row class="auth-inner m-0">
                <div class="w-100 d-flex flex-column justify-content-between">
                    <div class="mt-4  bg-white">
                        <div class="d-flex flex-column justify-content-center align-items-center mb-2 mt-3 px-2">
                            <div class="title"> Administración
                                de Animales
                            </div>
                        </div>
                        <div >

                            <b-row class="ml-5 mt-5">
                                <b-img src="@/assets/images/ganImage/icons/management.png" width="300px" style="margin:auto;"></b-img>
                            </b-row>
                            <b-row class="px-3">
                                <b-col>
                                    <b-button class="bg-primary mt-2 " block @click="navigateTo('advance-animals')" style="margin-bottom:100px;">
                                    <b-link style="color:white">Ver Animales</b-link>
                                    </b-button>
                                </b-col>
                            </b-row>
                            <b-row class="px-3" v-if="!isAdmin()"> 
                                <b-col>
                                    <b-button class="bg-primary mt-3 button-ingresar" block @click="navigateTo('advance-animalSwtich')">
                                    <b-link style="color:white"><b-img class="mr-5 " width="32px" src="@/assets/images/ganImage/icons/plus.png"></b-img>
                                        Nuevo Animal</b-link> 
                                    </b-button>

                                </b-col>
                            </b-row>
                            <b-row class="px-3" v-if="!isAdmin()">
                                <b-col>
                                    <b-button class="bg-primary mt-2 button-ingresar" block @click="navigateTo('advance-animalexit')">
                                    <b-link style="color:white"><b-img class="mr-2" width="28px"  src="@/assets/images/ganImage/icons/minus.png"></b-img>
                                        Salida de un Animal</b-link>
                                    </b-button>

                                </b-col>
                            </b-row>
                            <b-row class="px-3" v-if="!isAdmin()">
                                <b-col>
                                    <b-button class="bg-primary mt-2 " block @click="navigateTo('advance-animalbatch')">
                                    <b-link style="color:white">Crear Lotes</b-link>
                                    </b-button>
                                </b-col>
                            </b-row>
                            <b-row class="px-3">
                                <b-col>
                                    <b-button class="bg-primary mt-2 " block @click="navigateTo('advance-lots')" style="margin-bottom:100px;">
                                    <b-link style="color:white">Ver Lotes</b-link>
                                    </b-button>
                                </b-col>
                            </b-row>
                        </div>
                    </div>
                    <ControlMenu />
                </div>
            </b-row> 
        </div>
    </div>
</template>

<script>
import { BRow, BCol, BLink, BImg, BForm, BButton } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
export default {
    components: {
        BRow,
        BCol,
        BLink,
        BImg,
        BForm,
        BButton,
        ControlMenu,
        HeaderBar
    },
    data() {
        return {
            status: '',
            currentLevelAccess: localStorage.getItem("currentLevelAccess"),

        }
    },
    methods:{
        isAdmin() {
            return this.currentLevelAccess === "Visualizador";
        },
        navigateTo(routeName){
            this.$router.push({name:routeName});
        },
    }
    

}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
.title {
    font-family: 'Montserrat';
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    line-height: 29px;
    color: #5E5873;
}
</style>
